import { z } from "zod";

import { ESubscriberSignatureStatus } from "@/types/backoffice/dto/signature/signature-details-dto.ts";

export const escAcquisitionStateResponseDtoSchema = z.object({
  isEscEligible: z.boolean(),
  isUnderClearDaysConstraint: z.boolean().nullable(),
  status: z.nativeEnum(ESubscriberSignatureStatus).nullable(),
  installationAppointment: z.boolean().nullable(),
  installationMinimalDate: z.string().nullish(),
  reason: z.array(z.string()),
  hasElectricityBill: z.boolean().nullish(),
});

export type TEscAcquisitionStateResponseDto = z.infer<typeof escAcquisitionStateResponseDtoSchema>;
